import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import { ICommonLockingData, DeltaOf } from '@tencent/slide-sdk-model';
import { IElementModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';

/**
 * 锁定纵横比
 */
export class LockingConverter {
    /**
     * 锁定纵横比的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     * @param defaultUiLocking 当sdk没有设置锁定纵横比时，uiModel是否自动设置默认值
     */
    public static convertPartialDataFromSdkToUi(
        sdkData?: DeepReadonly<DeepPartial<ICommonLockingData>>,
        uiData?: IElementModelProps,
        defaultUiLocking?: boolean,
    ): void {
        if (!uiData) {
            return;
        }
        const locking = sdkData?.noChangeAspect;
        if (locking === true || locking === false) {
            uiData[Locks.LOCKS] = { noChangeAspect: locking ? 1 : 0 };
            return;
        }
        if (defaultUiLocking === true || defaultUiLocking === false) {
            // 兼容历史数据 旧逻辑：无论是否设置锁定纵横比属性，图片默认锁定纵横比
            uiData[Locks.LOCKS] = { noChangeAspect: defaultUiLocking ? 1 : 0 };
            return;
        }
        delete uiData[Locks.LOCKS];
    }

    /**
     * 锁定纵横比的ui -> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IElementModelProps>>,
        sdkData: DeltaOf<ICommonLockingData>,
    ): void {
        if (uiData[Locks.LOCKS]?.noChangeAspect === 1 || uiData[Locks.LOCKS]?.noChangeAspect === 0) {
            sdkData.noChangeAspect = !!uiData[Locks.LOCKS].noChangeAspect;
        }
    }
}
